import { Formik, FieldArray } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import { positiveNumber } from "../../../../utils/validations";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { clearCountryBasicDetail } from "../../../../../store/slices/country";
import SaveAndSaveNext from "../../../utils/saveAndSaveNext";
const BasicDetailForm = (props) => {
  const firstErrorRef = useRef(null);
  const dispatch = useDispatch();
  const { putCountryBasicDetailError, message, putCountryBasicDetailLoading } =
    useSelector((state) => state.cmsCountry);

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(clearCountryBasicDetail());
      }, 5000);
    }
  }, [message]);
  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert severity={putCountryBasicDetailError ? `error` : `success`}>
            {" "}
            {message}
          </Alert>
        )}
      </div>

      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!/^[1-9]\d*(\.\d{1,2})?[a-zA-Z]?$/.test(values.population) && values.population) {
            errors.population = "Value must be greater than 0";
          }
          if (!/^[1-9]\d*(\.\d{1,2})?[a-zA-Z]?$/.test(values.gdp) && values.gdp) {
            errors.gdp =
              "Ensure that there are no more than 2 digits after decimal";
          }
          if (
            !/^\d+(\.\d{1,2})?$/.test(values.employment_rate) &&
            values.employment_rate
          ) {
            errors.employment_rate =
              "Ensure that there are no more than 2 digits after decimal";
          }
          if (
            !/^\d+(\.\d{1,2})?$/.test(values.crime_rate) &&
            values.crime_rate
          ) {
            errors.crime_rate =
              "Ensure that there are no more than 2 digits after decimal";
          }
          if (
            !/^\d+(\.\d{1,2})?$/.test(values.literacy_rate) &&
            values.literacy_rate
          ) {
            errors.literacy_rate =
              "Ensure that there are no more than 2 digits after decimal";
          }
          values.country_living_costs?.forEach((element, index) => {
            if (values.country_living_costs[index]?.min_cost) {
              if(!/^(0|[1-9]\d*)$/.test(values.country_living_costs[index]?.min_cost)){
                errors[`country_living_costs.${index}.min_cost`] = "Must be an positve integer number only"
              }
            }
            if (values.country_living_costs[index]?.max_cost) {
              if(!/^(0|[1-9]\d*)$/.test(values.country_living_costs[index]?.max_cost)){
                errors[`country_living_costs.${index}.max_cost`] = "Must be an positve integer number only"
              }
            }
            if (
              parseInt(values.country_living_costs[index]?.min_cost) >=
              parseInt(values.country_living_costs[index]?.max_cost)
            ) {
              errors[`country_living_costs.${index}.min_cost`] =
                "Min Cost must be less than Max Cost";
            }
            Object.keys(errors).forEach((key) => {
              if (!errors[key]) {
                delete errors[key];
              }
            });
          });
          return errors;
        }}
        onSubmit={(values) => {
          props.submit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          setTouched,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h5>General Statistics</h5>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="population">
                      <Form.Label>Population</Form.Label>
                      <Form.Control
                        type="text"
                        name="population"
                        className={"input_pd"}
                        value={values?.population}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                    {errors?.population && touched?.population && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.population}
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="gdp">
                      <Form.Label>GDP</Form.Label>
                      <Form.Control
                        type="text"
                        name="gdp"
                        className={"input_pd"}
                        onBlur={handleBlur}
                        value={values?.gdp}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {errors?.gdp && touched?.gdp && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.gdp}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="employment_rate">
                      <Form.Label>Employment Rate</Form.Label>
                      <Form.Control
                        type="text"
                        name="employment_rate"
                        onBlur={handleBlur}
                        className={"input_pd"}
                        value={values?.employment_rate}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {errors?.employment_rate && touched?.employment_rate && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.employment_rate}
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="crime_rate">
                      <Form.Label>Crime Rate</Form.Label>
                      <Form.Control
                        type="text"
                        name="crime_rate"
                        className={"input_pd"}
                        value={values?.crime_rate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                    {errors?.crime_rate && touched?.crime_rate && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.crime_rate}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="literacy_rate">
                      <Form.Label>Literacy Rate</Form.Label>
                      <Form.Control
                        type="text"
                        name="literacy_rate"
                        className={"input_pd"}
                        onBlur={handleBlur}
                        value={values?.literacy_rate}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {errors?.literacy_rate && touched?.literacy_rate && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.literacy_rate}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
            {values.country_living_costs?.length > 0 && (
              <div className={"basic_details_country"}>
                <div className={"examfilter"}>
                  <h4 className={"examfilter_heading"}>Cost of Living</h4>
                  <FieldArray name="country_living_costs">
                    {({ insert, remove, push }) => (
                      <div>
                        {values.country_living_costs?.map((element, index) => (
                          <>
                            <Row>
                              <Col md={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="country_colleges"
                                >
                                  <Form.Label>Select Type</Form.Label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    name={`country_living_costs.${index}.cost_type`}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.label}
                                    value={props.costOfLivingOptions?.find(
                                      (obj) =>
                                        obj.value ===
                                        values?.country_living_costs[index]
                                          ?.cost_type
                                    ) ? props.costOfLivingOptions?.find(
                                      (obj) =>
                                        obj.value ===
                                        values?.country_living_costs[index]
                                          ?.cost_type
                                    ) : null  }
                                    onChange={(e) => {
                                      setFieldValue(
                                        `country_living_costs.${index}.cost_type`,
                                        e?.value
                                      );
                                    }}
                                    options={props?.costOfLivingOptions?.filter(
                                      (obj) =>
                                        !values?.country_living_costs
                                          ?.map(
                                            (innerObj) => innerObj?.cost_type
                                          )
                                          ?.includes(parseInt(obj.value))
                                    )}
                                    isClearable={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col>
                                <Form.Group
                                  className="mb-3"
                                  controlId={`min_cost_${index}`}
                                >
                                  <Form.Label>Min Cost</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`country_living_costs.${index}.min_cost`}
                                    className={"input_pd"}
                                    value={
                                      values.country_living_costs[index]
                                        .min_cost
                                    }
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `country_living_costs.${index}.min_cost`,
                                        e.target.value
                                      );
                                    }}
                                  />
                                </Form.Group>
                                {errors[
                                  `country_living_costs.${index}.min_cost`
                                ] &&
                                  touched[`country_living_costs`]?.[index]
                                    ?.min_cost && (
                                    <div ref={firstErrorRef} className="error">
                                      {
                                        errors[
                                          `country_living_costs.${index}.min_cost`
                                        ]
                                      }
                                    </div>
                                  )}
                              </Col>
                              <Col>
                                <Form.Group
                                  className="mb-3"
                                  controlId="max_cost"
                                >
                                  <Form.Label>Max Cost</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`country_living_costs.${index}.max_cost`}
                                    className={"input_pd"}
                                    onBlur={handleBlur}
                                    value={
                                      values?.country_living_costs[index]
                                        ?.max_cost
                                    }
                                    onChange={(e) =>
                                      setFieldValue(
                                        `country_living_costs.${index}.max_cost`,
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Group>
                                {errors[
                                  `country_living_costs.${index}.max_cost`
                                ] &&
                                  touched[`country_living_costs`]?.[index]
                                    ?.max_cost && (
                                    <div ref={firstErrorRef} className="error">
                                      {
                                        errors[
                                          `country_living_costs.${index}.max_cost`
                                        ]
                                      }
                                    </div>
                                  )}
                              </Col>
                              <Col
                                md={2}
                                className="bottom_right_button_container"
                              >
                                <div className={"imageField_fieldArray"}>
                                  <div className={"imageField_add"}>
                                    {values.country_living_costs?.length >
                                      1 && (
                                      <span
                                        className={"imageField_minus_icon"}
                                        onClick={() => {
                                          remove(index);
                                        }}
                                      >
                                        <AiFillMinusSquare />
                                      </span>
                                    )}
                                    {index ==
                                      values.country_living_costs?.length -
                                        1 && (
                                      <span
                                        className={"imageField_add_icon"}
                                        onClick={() =>
                                          push({
                                            cost_type: null,
                                            min_cost: "",
                                            max_cost: "",
                                          })
                                        }
                                      >
                                        <BsFillPlusSquareFill />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>
            )}
            <div className={"domain"}>
              <div className={"examfilter"}>
                <Row>
                  {values.last_updated && (
                    <span>Last Updated date: {values.last_updated}</span>
                  )}
                </Row>
                <Row>
                  {values.updated_by && (
                    <span>Updated by: {values.updated_by}</span>
                  )}
                </Row>
              </div>
            </div>

            <Row>
              <Col className="mt-3">
                <SaveAndSaveNext
                  firstErrorRef={firstErrorRef}
                  setTouched={setTouched}
                  errors={errors}
                  setSaveAndNext={props.setSaveAndNext}
                  loading={putCountryBasicDetailLoading}
                />
              </Col>
            </Row>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default BasicDetailForm;
